import { render, staticRenderFns } from "./Assignees.vue?vue&type=template&id=6f440b2a&scoped=true"
import script from "./Assignees.vue?vue&type=script&lang=js"
export * from "./Assignees.vue?vue&type=script&lang=js"
import style0 from "./Assignees.vue?vue&type=style&index=0&id=6f440b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f440b2a",
  null
  
)

export default component.exports